import { ConfigurationParentEventId, } from "../ConfigurationEvents/ConfigurationParentEvent";
/**
 * Ensure event is a ConfigurationParentEventUnion
 * @param event
 * @returns
 */
export function isConfigurationParentEvent(event) {
    if (typeof event !== "object") {
        return false;
    }
    if (event == null) {
        return false;
    }
    const parentEvent = event;
    if (!("cfgEvent" in parentEvent)) {
        return false;
    }
    if (typeof parentEvent.cfgEvent !== "string") {
        return false;
    }
    return Object.values(ConfigurationParentEventId).includes(parentEvent.cfgEvent);
}
//# sourceMappingURL=isConfigurationParentEvent.js.map